import { useEffect, useRef, useState } from 'react'
import { useNavigate, useParams  } from 'react-router-dom';
import { useAuth } from '../../context/AuthProvider/useAuth';
import logo from '../../assets/pilot_logo.png';
import React from 'react';
import { validateEmail } from '../../utils/formValidation';
import { notificationError, notificationSucces } from '../../services/notification';
import { useLoading } from '../../context/LoadingProvider/useLoading';
import { useForm, SubmitHandler } from "react-hook-form";
import showPwdImg from '../../assets/svg/show-password.svg';
import hidePwdImg from '../../assets/svg/hide-password.svg';

interface ILoginForm {
  email: string;
  password: string;
}

function Login() {
  const { param } = useParams()
  const { register, handleSubmit, formState: { errors } } = useForm<ILoginForm>({
    defaultValues: {
      email: '',
      password: ''
    }
  });
  const loading = useLoading()
  const history = useNavigate()
  const auth = useAuth()
  const [isRevealPwd, setIsRevealPwd] = useState(false);

  useEffect(() => {
    if(param === 'logoff') {
      notificationSucces('Signed out successfully')
    }
  },[])

  useEffect(()=> {
    if(auth.email) {

      return history('/welcome')
    }
  }, [auth.email])

  const onSubmit = async (data: ILoginForm) => {
    const {email, password} = data
    if(!email || !validateEmail(email)) return notificationError('Please enter a valid email')
    if(!password) return notificationError('Please enter your password')
    try {
      loading.addLoading()
      //await auth.authenticate(email, encodeURIComponent(password))
      await auth.authenticate(email, password)
      loading.removeLoading()
    } catch (e) {
      loading.removeLoading()
    }
  }

  return (
    <div className="login">
      <meta name="viewport" content="width=device-width, initial-scale=1"/>
      <div className="login__container">
        <img src={logo} className="login__logo" />
        <form className="login__form" onSubmit={handleSubmit(onSubmit)}>
          <div className="login__form__input">
            <input
              {...register("email", { required: 'This field is required'})} 
              type="email" 
              placeholder="Email" 
            />
            <p className="login__form__error">{ errors.email && errors.email.message + '*'}</p>
          </div>
          <div className="login__form__pwdinput">
            <input 
              {...register("password", { required: 'This field is required'})}
              type={isRevealPwd ? "text" : "password"} 
              placeholder="Password" 
            />
            <img 
              title={isRevealPwd ? "Hide password" : "Show password"}
              src={isRevealPwd ? hidePwdImg : showPwdImg}
              onClick={() => setIsRevealPwd(prevState => !prevState)}
            />
            <p className="login__form__error">{errors.password && errors.password.message + '*'}</p>
          </div>
          <div className="login__form__actions">
            <button type="submit" className="login__form__actions__button">LOGIN</button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default Login